import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

const adQueue = handleActions({
  PUSH_TO_AD_QUEUE: (state, { payload }) => state.concat(payload),

  SHIFT_AD_QUEUE: (state) => state.slice(1),
}, []);

const displayAdUpdate = handleActions({
  DISPLAY_AD_LOADED: (state, { payload }) => ({
    ...payload,
    displayAdCount: state.displayAdCount + 1,
  }),
}, {
  displayAdCount: 0,
});

const sovSeed = handleActions({
  UPDATE_SOV_SEED: (state, { payload }) => payload,
}, '');

const cookieConsent = handleActions({
	UPDATE_Cookie_Consent: (state, { payload }) => payload,
	}, '');

export default combineReducers({
  adQueue,
  displayAdUpdate,
  sovSeed,
  cookieConsent,
});



// WEBPACK FOOTER //
// ./src/reducer/ads.js